<template>
  <div>
    <CSidebarNavTitle v-if="hasAnyPerms([
      'dashboard.impersonate',
      'admin.collaborator.list',
      'invitation.list',
      'admin.role.list',
    ])">{{ $gettext('Permission Management') }}</CSidebarNavTitle>
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['dashboard.impersonate'])"
      :name="$gettext('Impersonate')"
      :to="{name: 'impersonate.users'}"
      icon="cip-glasses"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.collaborator.list', 'invitation.list'])"
      :name="$gettext('Global Collaborators')"
      :to="{name: 'admin.collaborators'}"
      icon="cip-add-user"
    />
    
    <CSidebarNavItem
      v-if="hasAnyPerms(['admin.role.list'])"
      :name="$gettext('Roles')"
      :to="{name: 'roles.list'}"
      icon="cip-users"
    />
  </div>
</template>

<script>
export default {
  name: 'PermissionManagement'
}
</script>